import { message } from 'antd';
import { post } from '@/utils/ApiUtil';

export type ResponseBody<T> = {
  costTime: number;
  errorCode?: string;
  errorMessages?: string | string[];
  result?: T;
  success: boolean;
};

export default function useLocalRequest<DataType>(url: string) {
  const run = async <ParamsType>(params?: ParamsType): Promise<ResponseBody<DataType>> => {
    const result = await post<ParamsType, DataType>(url, params as ParamsType);
    if (typeof result === 'string') {
      const [code, ...rest] = result.split('|');
      const errMsg = rest.join('|') || code;
      return {
        success: false,
        costTime: 0,
        errorCode: code,
        errorMessages: errMsg,
        result: undefined,
      };
    }
    return {
      success: true,
      costTime: 0,
      result: result as DataType,
    };
  };

  return {
    loading: false,
    data: undefined,
    error: undefined,
    run,
  };
}

let loading = false;
export const commonReq = async (
  cb: (handleErr: (msg?: unknown) => void) => Promise<unknown>,
  msg: unknown = '操作失败，请稍后重试',
  checkLoading = true,
) => {
  if (checkLoading && loading) {
    return;
  }
  checkLoading && (loading = true);
  const handleErr = (_msg?: unknown) => {
    if (!_msg) {
      _msg = msg;
    }
    if (typeof _msg === 'function') {
      (_msg as () => void)();
      return;
    }
    _msg && message.error(String(_msg));
  };
  let re;
  try {
    re = await cb(handleErr);
  } catch (e) {
    console.error(e);
    handleErr();
  }
  loading = false;
  return re;
};
